// Core
import {useState, useCallback, useMemo, useEffect} from 'react';
import {useQuery} from 'react-query';
import {useParams, useHistory} from 'react-router-dom';

// Assets
import {apiService} from 'services/ApiService';

// Components
import EditContent from './components/RoleEditContent';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';


const Edit = () => {
    const history = useHistory();
    const {id} = useParams();
    const [newObjectErrors, setNewObjectErrors] = useState([]);
    const [newObject, setNewObject] = useState({});
    const [errorCard, setErrorCard] = useState();
    const [selectedFile, setSelectedFile] = useState(null);
    const [isLoadingButton, setIsLoadingButton] = useState(false);

    const isRole = usePermissionStatusByKey('GET:/admin/roles/:id');
    const isCreateRole = usePermissionStatusByKey('POST:/admin/roles');

    useEffect(() => {
        if (id === 'new') {
            if (isCreateRole === false) {
                history.push('/permissions/roles');
            }
        } else {
            if (isRole === false) {
                history.push('/permissions/roles');
            }
        }
    }, [id, isCreateRole, isRole, history]);


    useMemo(() => {
        setErrorCard();
    }, [newObject]);


    const {isLoading, isError} = useQuery({
        queryKey: [id],
        refetchOnWindowFocus: false,
        refetchOnError: false,
        retry: false,

        queryFn: async () => {
            if (id === 'new') {
                const response = await apiService.getRoleTemplate();

                const roleTemplate = response.data;
                setNewObject({
                    name: '',
                    description: '',
                    capabilitiesGiveaways: roleTemplate,
                });
            } else {
                if (isRole) {
                    const response = await apiService.getRole({id});
                    const role = response.data;
                    setNewObject(
                        {
                            id: role.id,
                            name: role.name,
                            description: role.description,
                            capabilitiesGiveaways: role.capabilitiesGiveaways,
                        },
                    );
                }
            }

            return true;
        },
    });

    const handleCreateObject = useCallback(async () => {
        setIsLoadingButton(true);
        if (newObjectErrors.length > 0) {
            setIsLoadingButton(false);
            return;
        }

        const data = newObject;
        if (newObject.id) {
            try {
                const response = await apiService.updateRole(data);
                if (response.data === false || response.statusCode !== 200) {
                    setErrorCard(response.message);
                    setIsLoadingButton(false);
                    return;
                }
            } catch (e) {
                setErrorCard(true);
                setIsLoadingButton(false);
                return;
            }

        } else {
            try {
                const response = await apiService.createRole(data);
                if (response.data === false || response.statusCode !== 200) {
                    setErrorCard(response.message);
                    setIsLoadingButton(false);
                    return;
                }
            } catch (e) {
                setErrorCard(true);
                setIsLoadingButton(false);
                return;
            }
        }

        setIsLoadingButton(false);
        history.push('/permissions/roles');
        setNewObject({});
    }, [history, newObject, newObjectErrors]);

    const handleDelete = async (item) => {
        try {
            const response = await apiService.deleteRole(item);
            if (response.data === false || response.statusCode !== 200) {
                setErrorCard(response.message);
                return;
            }

            setNewObject({});
            history.push('/permissions/roles');
        } catch (e) {
            setErrorCard(true);
            return;
        }
    };

    return (isError ?
        <div>Not Found</div> : isLoading ?
            <div>Loading...</div> :
            <EditContent
                isLoadingButton={isLoadingButton}
                newObject={newObject}
                newObjectErrors={newObjectErrors}
                setNewObject={setNewObject}
                setSelectedFile={setSelectedFile}
                setNewObjectErrors={setNewObjectErrors}
                handleCreateObject={handleCreateObject}
                errorCard={errorCard}
                handleDelete={handleDelete}
            />);
};

export default Edit;
